var render = function () {
  var _vm$configuration;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: ['customizer-new-header', {
      'is-apac': _vm.regionIsApac
    }, {
      'customizer-new-header-canvas': _vm.canvasActiveTablet
    }]
  }, [_c('div', {
    class: ['customizer-new-header__container-logo-model-name', {
      'hide': _vm.canvasActiveMobile || _vm.canvasActiveTablet
    }]
  }, [_vm.showCustomizerHeaderLogo ? _c('button', {
    class: ['customizer-new-header__logo', this.themeLogo],
    attrs: {
      "aria-label": "Vans Customs Logo"
    },
    on: {
      "click": function click($event) {
        return _vm.changeExternalHeadersVisibility();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": this.logoImage,
      "alt": "Vans Customs Logo"
    }
  })]) : _vm._e(), _c('h1', {
    class: ['customizer-new-header__model-name', _vm.themeHeaderModelName]
  }, [_vm._v("\n      " + _vm._s(_vm.pdm.product_name) + "\n    ")]), _vm.configuration.enableAddToCartIcon && _vm.isMobile && _vm.itemsInCart >= 0 ? _c('a', {
    staticClass: "customizer-new-header__shopping-cart",
    attrs: {
      "href": (_vm$configuration = _vm.configuration) === null || _vm$configuration === void 0 ? void 0 : _vm$configuration.cartPath
    }
  }, [_c('img', {
    attrs: {
      "alt": "shopping cart icon",
      "aria-hidden": true,
      "src": _vm.customsAssets + '/svg/customizer/icon-shopping-cart.svg'
    }
  }), _c('div', [_vm._v(_vm._s(_vm.itemsInCart))])]) : _vm._e()]), !_vm.isMobile && _vm.configuration.enableCollapsableHeader ? _c('div', {
    class: ['customizer-new-header__container-other-buttons', _vm.themeHeaderOptions],
    style: {
      width: _vm.maxWidth + 'px'
    },
    attrs: {
      "aria-label": "Primary navigation menu"
    }
  }, _vm._l(_vm.desktopHeaderItems, function (item, index) {
    return _c('ul', {
      key: item.name,
      class: ['customizer-header-right-options-option--' + item.name, {
        'show-button-animation': item.name === 'finishMyDesign'
      }, 'customizer-new-header__option-button', {
        'customizer-new-header__option-button--disabled': _vm.rayTracerDisabled || item.disabled,
        'customizer-new-header__option-button--first': index === 0
      }],
      attrs: {
        "aria-hidden": !item.display
      },
      on: {
        "click": function click() {
          return _vm.openModal(_vm.desktopHeaderItems[index]);
        }
      }
    }, [_c('li', {
      staticClass: "outer-wrapper",
      style: item.display ? 'display:block' : 'display: none'
    }, [_c('button', {
      staticClass: "inner-wrapper"
    }, [_c('span', {
      staticClass: "customizer-new-header__option-name"
    }, [_vm._v("\n                " + _vm._s(_vm.translations[item.keyTranslate]) + "\n              ")]), _vm.configuration.enableCustomizerHeaderIcons !== false ? _c('div', {
      staticClass: "customizer-new-header__option-icon"
    }, [item.icon ? _c('span', {
      class: item.icon
    }) : _vm.customsAssets && item.url ? _c('img', {
      attrs: {
        "src": _vm.customsAssets + '/' + item.url
      }
    }) : _vm._e()]) : _vm._e()])])]);
  }), 0) : _vm._e(), !_vm.isMobile && _vm.configuration.enableCollapsableHeader && _vm.customOptions.length >= _vm.numDisplayedOptions ? _c('button', {
    staticClass: "collapse-header",
    attrs: {
      "aria-label": _vm.openHeader ? _vm.translations.groupShareClose : 'More actions',
      "aria-expanded": _vm.openHeader
    },
    on: {
      "click": _vm.openCollapsingHeader,
      "focus": _vm.resetTabIndexHeader
    }
  }, [_c('span', {
    staticClass: "icon-three-dots",
    style: !_vm.openHeader ? 'display:block' : 'display: none'
  }), _c('span', {
    staticClass: "icon-close",
    style: _vm.openHeader ? 'display:block' : 'display: none'
  })]) : _vm._e(), _vm.isMobile || !_vm.configuration.enableCollapsableHeader ? _c('div', {
    class: ['customizer-new-header__container-other-buttons', {
      'is-apac': _vm.regionIsApac
    }, _vm.themeHeaderOptions]
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    },
    on: {
      "click-slide": function clickSlide(index, reallyIndex) {
        return _vm.openModal(_vm.customOptions[index]);
      },
      "hook:updated": _vm.onSwiperUpdated
    }
  }, _vm._l(_vm.customOptions, function (item, index) {
    return _c('swiper-slide', {
      key: item.name,
      class: ['customizer-header-right-options-option--' + item.name, {
        'show-button-animation': item.name === 'finishMyDesign'
      }, 'customizer-new-header__option-button', {
        'customizer-new-header__option-button--disabled': _vm.rayTracerDisabled || item.disabled,
        'customizer-new-header__option-button--first': index === 0
      }]
    }, [_c('div', {
      staticClass: "outer-wrapper"
    }, [_c('div', {
      staticClass: "inner-wrapper"
    }, [_c('span', {
      staticClass: "customizer-new-header__option-name"
    }, [_vm._v("\n                " + _vm._s(_vm.translations[item.keyTranslate]) + "\n              ")]), _vm.configuration.enableCustomizerHeaderIcons !== false ? _c('div', {
      staticClass: "customizer-new-header__option-icon"
    }, [item.icon ? _c('span', {
      class: item.icon
    }) : _vm.customsAssets && item.url ? _c('img', {
      attrs: {
        "src": _vm.customsAssets + '/' + item.url
      }
    }) : _vm._e()]) : _vm._e()])])]);
  }), 1)], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.enableBuyPanel && !this.isMobile,
      expression: "this.enableBuyPanel && !this.isMobile"
    }],
    class: ['customizer-new-header__container-buy-button', 'customizer-new-header__container-buy-button--desktop', {
      'customizer-new-header__container-buy-button--disabled': _vm.rayTracerDisabled,
      'splash-desktop-modal-open-control': _vm.isSplashModalOpen && !_vm.isMobile && _vm.screenOrientation === 'landscape'
    }, _vm.themeBuyButton],
    style: _vm.themeBuyButtonStyle
  }, [_c('buy-button-label', {
    staticClass: "customizer-new-header__buy-button"
  })], 1), this.enableStartOver ? [_vm.configuration.enableNewStartOverModal && !_vm.configuration.modals.startOver ? _c('new-modal-wrapper', {
    attrs: {
      "widthModal": '90%',
      "maxWidthModal": 500,
      "modal-name": "newStartOverModal",
      "title": "startOverHeader",
      "cta-secondary-button": "startOverNo",
      "cta-primary-button": "startOverAccept"
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.$refs.content.ctaAction();
      }
    }
  }, [_c('start-over-component', {
    ref: "content"
  })], 1) : _c('start-over-modal')] : _vm._e(), this.enableFavorites ? [_vm.configuration.enableNewFavoritesModal && !_vm.configuration.modals.favorites ? _c('new-modal-wrapper', {
    attrs: {
      "widthModal": '90%',
      "maxWidthModal": 500,
      "modal-name": "newFavoritesModal",
      "title": "favoritesTitle"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var contentProps = _ref.contentProps;
        return [_c('favorites-component', {
          attrs: {
            "contentProps": contentProps
          }
        })];
      }
    }], null, false, 217271239)
  }) : _c('favorite-modal')] : _vm._e(), this.enableShare ? [!_vm.configuration.modals.shareYourDesign ? _c('share-your-design-modal', {
    attrs: {
      "enable-check": _vm.forceShareYourDesignCheck
    }
  }) : _c('share-your-design', {
    attrs: {
      "enable-check": _vm.forceShareYourDesignCheck
    }
  })] : _vm._e(), _vm.configuration.enableNewProductMissingModal ? _c('new-modal-wrapper', {
    attrs: {
      "widthModal": '90%',
      "maxWidthModal": 500,
      "modal-name": "productMissingModal",
      "cta-primary-button": "productMissingCta"
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.$modal.hide('productMissingModal');
      }
    }
  }, [_c('product-missing-modal')], 1) : _c('modal-wrapper', {
    attrs: {
      "modal-name": "productMissingModal",
      "title": "productMissingHeader",
      "content-component": "productMissingModal",
      "cta-button": "defaultRecipeContinueCustomizing"
    }
  }), _c('new-modal-wrapper', {
    attrs: {
      "widthModal": '90%',
      "maxWidthModal": 500,
      "modal-name": "genericErrorModal",
      "cta-primary-button": "passcodeContinue"
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.$modal.hide('genericErrorModal');
      }
    }
  }, [_c('generic-error-modal')], 1), _vm.tmallEnabled ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('tmall-wishlist-notification', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTmallWishlistNotification,
      expression: "showTmallWishlistNotification"
    }],
    attrs: {
      "favoriteSaved": _vm.tmallWishlistSaved
    }
  })], 1) : _vm._e(), _vm.enableTransferDesign ? [_vm.configuration.modals.transferDesign ? _c('transfer-design-modal') : _c('transfer-design-component')] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }